export default "__VITE_ASSET__fffececd__"